import { Component, Inject, OnInit } from '@angular/core';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet, MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { MatListModule } from '@angular/material/list';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { SharedModule } from '../../shared/shared.module';
import { environment } from '../../../environments/environment';
import { LocalStorageService } from '../../service/local-storage.service';

@Component({
  selector: 'app-main-member-list',
  templateUrl: './main-member-list.component.html',
  styleUrl: './main-member-list.component.scss'
})

export class MainMemberListComponent implements OnInit {
  baseUrl = environment.imageURL;
  panelOpenState = false;
  memberListData: any = [];
  childListData: any = [];
  currentOpenPanelIndex: number = -1;
  userTypeId: any;
  userId: any;
  mainMemberId: any;
  sub2 = new Subscription;
  originalMemberListData: any[] = [];
  sort: any;
  dateTimeStamp: any;
  loadingChildData: any;
  loginData: any;

  constructor(
    private mainService: MainService,
    private _bottomSheet: MatBottomSheet,
    private _router: Router,
    private localStorageService: LocalStorageService) {
    this.userTypeId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_type_id;
    this.userId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').user_id;
    this.mainMemberId = JSON.parse(this.localStorageService.getItem("loginData") || '{}').main_member_id;
    this.sub2 = this.mainService.sendFilterData().subscribe(res => {

      this.memberListData = this.originalMemberListData.filter((user: any) => {
        this.currentOpenPanelIndex = -1;

        const villageTrimmed = user.village_id.toString().trim().toLowerCase();
        const resVillageTrimmed = res.village_id.toString().trim().toLowerCase();
        const bloodGroupMatch = !res.blood_group || user.blood_group.toLowerCase() === res.blood_group.toLowerCase();

        const villageNameMatch = !res.village_id || villageTrimmed === resVillageTrimmed;
        // const DistrictMatch = !res.district_name || user.district_name.toLowerCase().includes(res.district_name.toLowerCase());
        // const SubdivisionMatch = !res.subdivision_name || user.subdivision_name.toLowerCase().includes(res.subdivision_name.toLowerCase());

        //const villageNameMatch = !res.village_id || user.village_id.toLowerCase() === res.village_id.toLowerCase();                       
        return bloodGroupMatch && villageNameMatch;
      });

    })
  }

  openBottomSheet(): void {
    this._bottomSheet.open(FilterMemberForm, {
      data: this.memberListData,
    });
  }

  ngOnInit(): void {
    this.getMainMember();
  }

  getMainMember() {
    this.currentOpenPanelIndex = -1;
    this.memberListData = [];
    this.originalMemberListData = [];
    if (this.userTypeId == 1) {
      this.mainService.getApi(ApiUrls.adminMemberList).subscribe((res: any) => {
        if (res.status == 1) {
          res.user.forEach((item: any) => {
            item.dateTimeStamp = Math.random();
          });
          this.memberListData = res.user.filter((user: any) => user.user_type_id !== 1);
          this.originalMemberListData = res.user.filter((user: any) => user.user_type_id !== 1);
          this.memberListData = [...res.user.filter((user: any) => user.user_type_id !== 1)];
        }
      });
    } else {
      this.mainService.getApi(ApiUrls.memberList).subscribe((res: any) => {
        if (res.status == 1) {
          res.user.forEach((item: any) => {
            item.dateTimeStamp = Math.random();
          });
          if (this.userTypeId == 1) {
            this.memberListData = res.user.filter((user: any) => user.user_type_id !== 1);
            this.originalMemberListData = res.user.filter((user: any) => user.user_type_id !== 1);
            this.memberListData = [...res.user.filter((user: any) => user.user_type_id !== 1)];
          } else if (this.userTypeId != 1 && this.mainMemberId == 0) {
            this.originalMemberListData = res.user.filter((x: any) => x.user_id == this.userId)
            this.memberListData = res.user.filter((x: any) => x.user_id == this.userId)
          } else {
            this.originalMemberListData = res.user.filter((x: any) => x.user_id == this.mainMemberId)
            this.memberListData = res.user.filter((x: any) => x.user_id == this.mainMemberId)
          }
        }
      });
    }
  }

  //for no data found reload condition
  getChildMemberList(data: any) {
    this.childListData = [];
    this.loadingChildData = true;
    setTimeout(() => {
      this.mainService.getApi(ApiUrls.listByMemberId + data.user_id).subscribe((res: any) => {
        if (res.status === 1) {
          this.childListData = res.user;
        }
        this.loadingChildData = false;
      });
    }, 150);
  }

  searchMember(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.memberListData = [...this.originalMemberListData]; // Reset to original data
      return;
    }
    this.memberListData = this.originalMemberListData.filter((user: any) => {
      return user.name.toLowerCase().includes(filterValue) ||
        user.city_name.toLowerCase().includes(filterValue) ||
        user.contact_no.includes(filterValue);
    });
  }

  addMember(id: any, action: any) {
    if (this.mainMemberId != 0 && this.userId == id) {
      this._router.navigate(["/profile/" + id + '/' + action + '/' + 'memberPage']);
    } else if (this.mainMemberId == 0) {
      this._router.navigate(["/profile/" + id + '/' + action + '/' + 'memberPage']);
    }
  }
}

@Component({
  selector: 'app-filter-member',
  templateUrl: 'filter-member.component.html',
  standalone: true,
  imports: [MatListModule, CommonModule, SharedModule],
})
export class FilterMemberForm implements OnInit {
  dataDistrictList: any = [];
  subdivisionList: any = [];
  villageList: any = [];
  selectedDistrictId: any = 0;
  selectedSubdivisionId: any = 0;
  filter_memberForm: FormGroup;

  constructor(
    private _bottomSheetRef: MatBottomSheetRef<FilterMemberForm>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
    private mainService: MainService,
    private fb: FormBuilder
  ) {
    this.filter_memberForm = this.fb.group({
      blood_group: [''],
      district_name: [''],
      subdivision_name: [''],
      village_name: [''],
      contact_no: [''],
    })
  }

  ngOnInit(): void {
    this.getDistrict()
  }

  getDistrict() {
    this.mainService.getApi(ApiUrls.districtList).subscribe((res: any) => {
      this.dataDistrictList = res.district.filter((x: any) => x.is_active == 1);
    })
  }

  onDistrict_Id(event: any) {
    const selectedDistrictId = event.target.value;
    const selectedDistrict = this.dataDistrictList.find((district: any) => district.district_id == selectedDistrictId);
    this.selectedDistrictId = selectedDistrictId;
    this.getSubdivision(this.selectedDistrictId);
  }

  getSubdivision(id: any) {
    this.mainService.getApi(ApiUrls.subdivisionListSelect + id).subscribe((res: any) => {
      this.subdivisionList = res.subdivision.filter((x: any) => x.is_active == 1);
    });
  }

  onSubdivision_Id(event: any) {
    const selectedSubdivisionId = event.target.value;
    const selectedSubdivision = this.subdivisionList.find((subdivision: any) => subdivision.subdivision_id == selectedSubdivisionId);
    this.selectedSubdivisionId = selectedSubdivisionId;
    this.getVillages(this.selectedSubdivisionId);
  }

  getVillages(id: any) {
    this.mainService.getApi(ApiUrls.villageListSelect + id).subscribe((res: any) => {
      this.villageList = res.village.filter((x: any) => x.is_active == 1);
    });
  }

  Cancel() {
    this._bottomSheetRef.dismiss();
  }

  submit() {
    let data = {
      blood_group: this.filter_memberForm.value.blood_group,
      district_id: this.filter_memberForm.value.district_name,
      subdivision_id: this.filter_memberForm.value.subdivision_name,
      village_id: this.filter_memberForm.value.village_name,
      contact_no: this.filter_memberForm.value.contact_no,
    }
    this.mainService.getFilterData(data);
    this._bottomSheetRef.dismiss();
  }

}